<div *ngIf="showLoading" class="reward-detail-loading" aria-live="polite" aria-busy="true" role="alert" tabindex="2">
    <div class="loading-spinner">
        <div class="large progress" alt="Loading..." aria-label="Loading...">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!showLoading">
    <ng-container *ngIf="!isErrorInContent">
        <div>
            <div class="px-2">
                <div class="pds-accordion">
                    <h2 class="py-3 mb-0">
                        <button class="pds-accordion__header d-flex align-items-center justify-content-between pl-0 w-100 border-0 bg-transparent"
                                data-toggle="collapse" data-target="#partnerTerms" aria-expanded="false"
                                aria-controls="partnerTerms" id="termsHeading"><span class="poppins-title-lg"
                                                                                     style="text-align: left; color: #2a2928;">Terms &amp; conditions</span><span
                                class="svg-caret-collapse-md"></span><span class="svg-caret-expand-md"></span></button>
                    </h2>
                </div>
                <div id="partnerTerms" class="collapse" role="region" aria-labelledby="termsHeading">
                    <div>
                        <!-- paste terms & conditions here -->
                        <div [innerHTML]="termsContent | safeHtml" class=""></div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="isErrorInContent">
    </ng-container>
</div>
